/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

type Props = {
  tagName: string;
  icon: React.ReactNode;
};

const TagWithIcon = ({ tagName, icon }: Props) => {
  return (
    <>
      {icon}
      <span>{tagName}</span>
    </>
  );
};

export default TagWithIcon;
